import React from 'react';
import './style.scss';
import Layout from 'Layout';
import Navbar from './component/Navbar';

interface UserAccountLayoutProps {
  children?: React.ReactNode;
}

const UserAccountLayout: React.FC<UserAccountLayoutProps> = ({ children }) => {
    return (
        <Layout>
            <div className='user-account-page'>
                <nav className="breadcrumb">
                    <a href="/">Home</a>
                    <span> &gt; </span>
                    <span>Account</span>
                </nav>
                <div className='container-user'>
                    <Navbar/>
                    <div className="right-content">
                        {children}
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default UserAccountLayout;